enum ReturnPolicys {
  StorePolicy = 'STORE_POLICY',
  External = 'EXTERNAL',
  None = 'NONE',
}

type JSONTrackingConfig = {
  return_policy_source: Maybe<string>;
  return_policy_url: Maybe<string>;
  spotlight_title: Maybe<string>;
  recommendation_title: Maybe<string>;
  recommendation_title_tracking: Maybe<string>;
};

type TrackingConfig = {
  returnPolicySource: Maybe<string>;
  returnPolicyUrl: Maybe<string>;
  spotlightTitle: Maybe<string>;
  recommendationTitle: Maybe<string>;
  recommendationTitleTracking: Maybe<string>;
};

type BrandAndFooter = {
  replyToEmail: Maybe<string>;
  returnPolicySource: Maybe<string>;
  returnPolicyUrl?: Maybe<string>;
  spotlightTitle?: Maybe<string>;
  recommendationTitle?: Maybe<string>;
};

function setTrackingConfigPayload(trackingConfig: TrackingConfig, payload: BrandAndFooter) {
  return {
    returnPolicySource: payload.returnPolicySource,
    returnPolicyUrl: payload.returnPolicyUrl,
    spotlightTitle: payload.spotlightTitle,
    recommendationTitle: payload.recommendationTitle,
    recommendationTitleTracking: trackingConfig.recommendationTitleTracking,
  };
}
function fromJSON(jsonTrack: JSONTrackingConfig): TrackingConfig {
  return {
    returnPolicySource: jsonTrack.return_policy_source,
    returnPolicyUrl: jsonTrack.return_policy_url,
    spotlightTitle: jsonTrack.spotlight_title,
    recommendationTitle: jsonTrack.recommendation_title,
    recommendationTitleTracking: jsonTrack.recommendation_title_tracking,
  };
}

function toJSON(jsonTrack: TrackingConfig): JSONTrackingConfig {
  return {
    return_policy_source: jsonTrack.returnPolicySource || ReturnPolicys.None,
    return_policy_url:
      jsonTrack.returnPolicySource === ReturnPolicys.External ? jsonTrack.returnPolicyUrl : null,
    spotlight_title: jsonTrack.spotlightTitle || null,
    recommendation_title: jsonTrack.recommendationTitle || null,
    recommendation_title_tracking: jsonTrack.recommendationTitleTracking || null,
  };
}

export {
  BrandAndFooter,
  ReturnPolicys,
  JSONTrackingConfig,
  TrackingConfig,
  fromJSON,
  toJSON,
  setTrackingConfigPayload,
};
